var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _mask, _path4, _path5, _path6, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _path7, _path8, _circle23, _mask2, _path9, _path10, _path11, _circle24, _circle25, _circle26, _circle27, _mask3, _path12, _path13, _path14, _circle28, _circle29, _circle30, _circle31, _mask4, _path15, _path16, _path17, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _path18, _path19, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _mask5, _path20, _path21, _path22, _circle48, _circle49, _circle50, _circle51, _mask6, _path23, _path24, _path25, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimesheetStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 131,
    viewBox: "0 0 208 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V162H207V7C207 3.68629 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 58C41.5228 58 46 53.5228 46 48C46 42.4772 41.5228 38 36 38C30.4772 38 26 42.4772 26 48C26 53.5228 30.4772 58 36 58Z",
    fill: "#A6A8AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8005 51.102C38.759 51.102 38.7175 51.0606 38.676 51.0606C38.0536 50.8116 37.1822 50.3137 37.1822 49.6083C37.1822 48.5294 38.427 48.3635 38.593 46.1643C38.7175 44.3801 37.7631 43.0938 35.9789 43.0938C34.1947 43.0938 33.2403 44.3801 33.3648 46.1643C33.5308 48.405 34.7756 48.5709 34.7756 49.6083C34.7756 50.3137 33.9042 50.8116 33.2818 51.0606C33.2403 51.0606 33.1988 51.102 33.1573 51.102C32.8254 51.268 32.5764 51.6415 32.5764 52.0564C32.5764 52.6373 33.0328 53.0938 33.6138 53.0938H35.9789H38.344C38.925 53.0938 39.3814 52.6373 39.3814 52.0564C39.4229 51.6415 39.1739 51.268 38.8005 51.102Z",
    fill: "#BBBDBF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 48.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 48.246,
    r: 11.3585,
    fill: "#B3B3B3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 48.246,
    r: 11.246,
    fill: "#B3B3B3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2461,
    cy: 48.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 48.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2461,
    cy: 48.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 48.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 48.246,
    r: 11.3585,
    fill: "#B3B3B3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 48.246,
    r: 11.246,
    fill: "#B3B3B3"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 48.246,
    r: 9.33421,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 48.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 48.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 48.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 123.984,
    y: 36,
    width: 24,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 123.984,
    y: 36,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78 42.1491C125.419 44.2594 124.803 46.7646 125.03 49.2656C125.258 51.7666 126.316 54.1194 128.037 55.9491C129.757 57.7788 132.04 58.9801 134.522 59.3616C137.004 59.743 139.543 59.2827 141.733 58.0539C143.923 56.8251 145.639 54.8986 146.607 52.5814C147.575 50.2641 147.74 47.6895 147.075 45.2679C146.41 42.8462 144.953 40.7168 142.937 39.219C140.922 37.7213 138.462 36.9413 135.952 37.0034L136.23 48.246L126.78 42.1491Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 42.1491C125.419 44.2594 124.803 46.7646 125.03 49.2656C125.258 51.7666 126.316 54.1194 128.037 55.9491C129.757 57.7788 132.04 58.9801 134.522 59.3616C137.004 59.743 139.543 59.2827 141.733 58.0539C143.923 56.8251 145.639 54.8986 146.607 52.5814C147.575 50.2641 147.74 47.6895 147.075 45.2679C146.41 42.8462 144.953 40.7168 142.937 39.219C140.922 37.7213 138.462 36.9413 135.952 37.0034L136.23 48.246L126.78 42.1491Z",
    fill: "#B3B3B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 42.1491C125.419 44.2594 124.803 46.7646 125.03 49.2656C125.258 51.7666 126.316 54.1194 128.037 55.9491C129.757 57.7788 132.04 58.9801 134.522 59.3616C137.004 59.743 139.543 59.2827 141.733 58.0539C143.923 56.8251 145.639 54.8986 146.607 52.5814C147.575 50.2641 147.74 47.6895 147.075 45.2679C146.41 42.8462 144.953 40.7168 142.937 39.219C140.922 37.7213 138.462 36.9413 135.952 37.0034L136.23 48.246L126.78 42.1491Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.449841,
    mask: "url(#path-17-outside-1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.278 56.1982C129.594 57.5141 131.216 58.4829 132.998 59.0177C134.781 59.5525 136.668 59.6366 138.491 59.2624C140.314 58.8883 142.016 58.0676 143.444 56.8739C144.871 55.6802 145.981 54.1509 146.672 52.423C147.363 50.6951 147.615 48.8227 147.404 46.9737C147.193 45.1246 146.527 43.3567 145.465 41.8285C144.403 40.3003 142.979 39.0594 141.319 38.2173C139.66 37.3752 137.817 36.9581 135.957 37.0033L136.23 48.246L128.278 56.1982Z",
    fill: "#B3B3B3"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 48.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 48.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 48.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 48.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 48.246,
    r: 11.3585,
    fill: "#B3B3B3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 48.246,
    r: 11.246,
    fill: "#B3B3B3"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 48.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 48.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 48.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 90C41.5228 90 46 85.5228 46 80C46 74.4772 41.5228 70 36 70C30.4772 70 26 74.4772 26 80C26 85.5228 30.4772 90 36 90Z",
    fill: "#A6A8AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8005 83.102C38.759 83.102 38.7175 83.0606 38.676 83.0606C38.0536 82.8116 37.1822 82.3137 37.1822 81.6083C37.1822 80.5294 38.427 80.3635 38.593 78.1643C38.7175 76.3801 37.7631 75.0938 35.9789 75.0938C34.1947 75.0938 33.2403 76.3801 33.3648 78.1643C33.5308 80.405 34.7756 80.5709 34.7756 81.6083C34.7756 82.3137 33.9042 82.8116 33.2818 83.0606C33.2403 83.0606 33.1988 83.102 33.1573 83.102C32.8254 83.268 32.5764 83.6415 32.5764 84.0564C32.5764 84.6373 33.0328 85.0938 33.6138 85.0938H35.9789H38.344C38.925 85.0938 39.3814 84.6373 39.3814 84.0564C39.4229 83.6415 39.1739 83.268 38.8005 83.102Z",
    fill: "#BBBDBF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 80.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-31-outside-2",
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 68,
    width: 21,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 64,
    y: 68,
    width: 21,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2939 88.1982C66.6016 89.5059 68.2117 90.471 69.9815 91.0078C71.7513 91.5447 73.6261 91.6368 75.44 91.276C77.2539 90.9152 78.9508 90.1126 80.3804 88.9393C81.8101 87.7661 82.9283 86.2583 83.636 84.5497C84.3438 82.8411 84.6192 80.9842 84.4379 79.1437C84.2566 77.3032 83.6242 75.5358 82.5968 73.9981C81.5693 72.4603 80.1784 71.1997 78.5474 70.3279C76.9163 69.4561 75.0955 69 73.246 69L73.246 80.246L65.2939 88.1982Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2939 88.1982C66.6016 89.5059 68.2117 90.471 69.9815 91.0078C71.7513 91.5447 73.6261 91.6368 75.44 91.276C77.2539 90.9152 78.9508 90.1126 80.3804 88.9393C81.8101 87.7661 82.9283 86.2583 83.636 84.5497C84.3438 82.8411 84.6192 80.9842 84.4379 79.1437C84.2566 77.3032 83.6242 75.5358 82.5968 73.9981C81.5693 72.4603 80.1784 71.1997 78.5474 70.3279C76.9163 69.4561 75.0955 69 73.246 69L73.246 80.246L65.2939 88.1982Z",
    fill: "#B3B3B3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2939 88.1982C66.6016 89.5059 68.2117 90.471 69.9815 91.0078C71.7513 91.5447 73.6261 91.6368 75.44 91.276C77.2539 90.9152 78.9508 90.1126 80.3804 88.9393C81.8101 87.7661 82.9283 86.2583 83.636 84.5497C84.3438 82.8411 84.6192 80.9842 84.4379 79.1437C84.2566 77.3032 83.6242 75.5358 82.5968 73.9981C81.5693 72.4603 80.1784 71.1997 78.5474 70.3279C76.9163 69.4561 75.0955 69 73.246 69L73.246 80.246L65.2939 88.1982Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.449841,
    mask: "url(#path-31-outside-2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2939 88.1982C66.6098 89.5141 68.2317 90.4829 70.0142 91.0177C71.7967 91.5525 73.6841 91.6366 75.5071 91.2624C77.3301 90.8883 79.0317 90.0676 80.4595 88.8739C81.8872 87.6802 82.9964 86.1509 83.6876 84.423C84.3788 82.6951 84.6304 80.8227 84.4199 78.9737C84.2093 77.1246 83.5432 75.3567 82.4812 73.8285C81.4192 72.3003 79.9946 71.0594 78.335 70.2173C76.6755 69.3752 74.8329 68.9581 72.9724 69.0033L73.246 80.246L65.2939 88.1982Z",
    fill: "#B3B3B3"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2462,
    cy: 80.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 80.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2461,
    cy: 80.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 80.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-37-outside-3",
    maskUnits: "userSpaceOnUse",
    x: 92.4921,
    y: 68,
    width: 24,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 92.4921,
    y: 68,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2882 74.1491C93.9267 76.2594 93.3107 78.7646 93.5384 81.2656C93.7661 83.7666 94.8243 86.1194 96.5445 87.9491C98.2646 89.7788 100.548 90.9801 103.03 91.3616C105.512 91.743 108.051 91.2827 110.241 90.0539C112.431 88.8251 114.147 86.8986 115.115 84.5814C116.083 82.2641 116.248 79.6895 115.583 77.2679C114.918 74.8462 113.461 72.7168 111.445 71.219C109.429 69.7213 106.97 68.9413 104.46 69.0034L104.738 80.246L95.2882 74.1491Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2882 74.1491C93.9267 76.2594 93.3107 78.7646 93.5384 81.2656C93.7661 83.7666 94.8243 86.1194 96.5445 87.9491C98.2646 89.7788 100.548 90.9801 103.03 91.3616C105.512 91.743 108.051 91.2827 110.241 90.0539C112.431 88.8251 114.147 86.8986 115.115 84.5814C116.083 82.2641 116.248 79.6895 115.583 77.2679C114.918 74.8462 113.461 72.7168 111.445 71.219C109.429 69.7213 106.97 68.9413 104.46 69.0034L104.738 80.246L95.2882 74.1491Z",
    fill: "#B3B3B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2882 74.1491C93.9267 76.2594 93.3107 78.7646 93.5384 81.2656C93.7661 83.7666 94.8243 86.1194 96.5445 87.9491C98.2646 89.7788 100.548 90.9801 103.03 91.3616C105.512 91.743 108.051 91.2827 110.241 90.0539C112.431 88.8251 114.147 86.8986 115.115 84.5814C116.083 82.2641 116.248 79.6895 115.583 77.2679C114.918 74.8462 113.461 72.7168 111.445 71.219C109.429 69.7213 106.97 68.9413 104.46 69.0034L104.738 80.246L95.2882 74.1491Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.449841,
    mask: "url(#path-37-outside-3)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.786 88.1982C98.1019 89.5141 99.7238 90.4829 101.506 91.0177C103.289 91.5525 105.176 91.6366 106.999 91.2624C108.822 90.8883 110.524 90.0676 111.952 88.8739C113.379 87.6802 114.488 86.1509 115.18 84.423C115.871 82.6951 116.122 80.8227 115.912 78.9737C115.701 77.1246 115.035 75.3567 113.973 73.8285C112.911 72.3003 111.487 71.0594 109.827 70.2173C108.168 69.3752 106.325 68.9581 104.465 69.0033L104.738 80.246L96.786 88.1982Z",
    fill: "#B3B3B3"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 80.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 80.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 80.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 80.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-43-outside-4",
    maskUnits: "userSpaceOnUse",
    x: 123.984,
    y: 68,
    width: 24,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 123.984,
    y: 68,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78 74.1491C125.419 76.2594 124.803 78.7646 125.03 81.2656C125.258 83.7666 126.316 86.1194 128.037 87.9491C129.757 89.7788 132.04 90.9801 134.522 91.3616C137.004 91.743 139.543 91.2827 141.733 90.0539C143.923 88.8251 145.639 86.8986 146.607 84.5814C147.575 82.2641 147.74 79.6895 147.075 77.2679C146.41 74.8462 144.953 72.7168 142.937 71.219C140.922 69.7213 138.462 68.9413 135.952 69.0034L136.23 80.246L126.78 74.1491Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 74.1491C125.419 76.2594 124.803 78.7646 125.03 81.2656C125.258 83.7666 126.316 86.1194 128.037 87.9491C129.757 89.7788 132.04 90.9801 134.522 91.3616C137.004 91.743 139.543 91.2827 141.733 90.0539C143.923 88.8251 145.639 86.8986 146.607 84.5814C147.575 82.2641 147.74 79.6895 147.075 77.2679C146.41 74.8462 144.953 72.7168 142.937 71.219C140.922 69.7213 138.462 68.9413 135.952 69.0034L136.23 80.246L126.78 74.1491Z",
    fill: "#B3B3B3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 74.1491C125.419 76.2594 124.803 78.7646 125.03 81.2656C125.258 83.7666 126.316 86.1194 128.037 87.9491C129.757 89.7788 132.04 90.9801 134.522 91.3616C137.004 91.743 139.543 91.2827 141.733 90.0539C143.923 88.8251 145.639 86.8986 146.607 84.5814C147.575 82.2641 147.74 79.6895 147.075 77.2679C146.41 74.8462 144.953 72.7168 142.937 71.219C140.922 69.7213 138.462 68.9413 135.952 69.0034L136.23 80.246L126.78 74.1491Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.449841,
    mask: "url(#path-43-outside-4)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.278 88.1982C129.594 89.5141 131.216 90.4829 132.998 91.0177C134.781 91.5525 136.668 91.6366 138.491 91.2624C140.314 90.8883 142.016 90.0676 143.444 88.8739C144.871 87.6802 145.981 86.1509 146.672 84.423C147.363 82.6951 147.615 80.8227 147.404 78.9737C147.193 77.1246 146.527 75.3567 145.465 73.8285C144.403 72.3003 142.979 71.0594 141.319 70.2173C139.66 69.3752 137.817 68.9581 135.957 69.0033L136.23 80.246L128.278 88.1982Z",
    fill: "#B3B3B3"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 80.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 80.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 80.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 80.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 80.246,
    r: 11.3585,
    fill: "#B3B3B3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 80.246,
    r: 11.246,
    fill: "#B3B3B3"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 80.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 80.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 80.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 122C41.5228 122 46 117.523 46 112C46 106.477 41.5228 102 36 102C30.4772 102 26 106.477 26 112C26 117.523 30.4772 122 36 122Z",
    fill: "#A6A8AB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8005 115.102C38.759 115.102 38.7175 115.061 38.676 115.061C38.0536 114.812 37.1822 114.314 37.1822 113.608C37.1822 112.529 38.427 112.363 38.593 110.164C38.7175 108.38 37.7631 107.094 35.9789 107.094C34.1947 107.094 33.2403 108.38 33.3648 110.164C33.5308 112.405 34.7756 112.571 34.7756 113.608C34.7756 114.314 33.9042 114.812 33.2818 115.061C33.2403 115.061 33.1988 115.102 33.1573 115.102C32.8254 115.268 32.5764 115.641 32.5764 116.056C32.5764 116.637 33.0328 117.094 33.6138 117.094H35.9789H38.344C38.925 117.094 39.3814 116.637 39.3814 116.056C39.4229 115.641 39.1739 115.268 38.8005 115.102Z",
    fill: "#BBBDBF"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 112.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 112.246,
    r: 11.3585,
    fill: "#B3B3B3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 112.246,
    r: 11.246,
    fill: "#B3B3B3"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2461,
    cy: 112.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.246,
    cy: 112.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2461,
    cy: 112.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 112.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-63-outside-5",
    maskUnits: "userSpaceOnUse",
    x: 95.4921,
    y: 100,
    width: 21,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 95.4921,
    y: 100,
    width: 21,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.786 120.198C98.0937 121.506 99.7038 122.471 101.474 123.008C103.243 123.545 105.118 123.637 106.932 123.276C108.746 122.915 110.443 122.113 111.873 120.939C113.302 119.766 114.42 118.258 115.128 116.55C115.836 114.841 116.111 112.984 115.93 111.144C115.749 109.303 115.116 107.536 114.089 105.998C113.061 104.46 111.67 103.2 110.039 102.328C108.408 101.456 106.588 101 104.738 101L104.738 112.246L96.786 120.198Z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M96.786 120.198C98.0937 121.506 99.7038 122.471 101.474 123.008C103.243 123.545 105.118 123.637 106.932 123.276C108.746 122.915 110.443 122.113 111.873 120.939C113.302 119.766 114.42 118.258 115.128 116.55C115.836 114.841 116.111 112.984 115.93 111.144C115.749 109.303 115.116 107.536 114.089 105.998C113.061 104.46 111.67 103.2 110.039 102.328C108.408 101.456 106.588 101 104.738 101L104.738 112.246L96.786 120.198Z",
    fill: "#B3B3B3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.786 120.198C98.0937 121.506 99.7038 122.471 101.474 123.008C103.243 123.545 105.118 123.637 106.932 123.276C108.746 122.915 110.443 122.113 111.873 120.939C113.302 119.766 114.42 118.258 115.128 116.55C115.836 114.841 116.111 112.984 115.93 111.144C115.749 109.303 115.116 107.536 114.089 105.998C113.061 104.46 111.67 103.2 110.039 102.328C108.408 101.456 106.588 101 104.738 101L104.738 112.246L96.786 120.198Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.449841,
    mask: "url(#path-63-outside-5)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.786 120.198C98.1019 121.514 99.7238 122.483 101.506 123.018C103.289 123.552 105.176 123.637 106.999 123.262C108.822 122.888 110.524 122.068 111.952 120.874C113.379 119.68 114.488 118.151 115.18 116.423C115.871 114.695 116.122 112.823 115.912 110.974C115.701 109.125 115.035 107.357 113.973 105.828C112.911 104.3 111.487 103.059 109.827 102.217C108.168 101.375 106.325 100.958 104.465 101.003L104.738 112.246L96.786 120.198Z",
    fill: "#B3B3B3"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 112.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 112.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.738,
    cy: 112.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 112.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-69-outside-6",
    maskUnits: "userSpaceOnUse",
    x: 123.984,
    y: 100,
    width: 24,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 123.984,
    y: 100,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78 106.149C125.419 108.259 124.803 110.765 125.03 113.266C125.258 115.767 126.316 118.119 128.037 119.949C129.757 121.779 132.04 122.98 134.522 123.362C137.004 123.743 139.543 123.283 141.733 122.054C143.923 120.825 145.639 118.899 146.607 116.581C147.575 114.264 147.74 111.69 147.075 109.268C146.41 106.846 144.953 104.717 142.937 103.219C140.922 101.721 138.462 100.941 135.952 101.003L136.23 112.246L126.78 106.149Z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 106.149C125.419 108.259 124.803 110.765 125.03 113.266C125.258 115.767 126.316 118.119 128.037 119.949C129.757 121.779 132.04 122.98 134.522 123.362C137.004 123.743 139.543 123.283 141.733 122.054C143.923 120.825 145.639 118.899 146.607 116.581C147.575 114.264 147.74 111.69 147.075 109.268C146.41 106.846 144.953 104.717 142.937 103.219C140.922 101.721 138.462 100.941 135.952 101.003L136.23 112.246L126.78 106.149Z",
    fill: "#B3B3B3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 106.149C125.419 108.259 124.803 110.765 125.03 113.266C125.258 115.767 126.316 118.119 128.037 119.949C129.757 121.779 132.04 122.98 134.522 123.362C137.004 123.743 139.543 123.283 141.733 122.054C143.923 120.825 145.639 118.899 146.607 116.581C147.575 114.264 147.74 111.69 147.075 109.268C146.41 106.846 144.953 104.717 142.937 103.219C140.922 101.721 138.462 100.941 135.952 101.003L136.23 112.246L126.78 106.149Z",
    stroke: "#DDDDDD",
    strokeWidth: 0.449841,
    mask: "url(#path-69-outside-6)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.278 120.198C129.594 121.514 131.216 122.483 132.998 123.018C134.781 123.552 136.668 123.637 138.491 123.262C140.314 122.888 142.016 122.068 143.444 120.874C144.871 119.68 145.981 118.151 146.672 116.423C147.363 114.695 147.615 112.823 147.404 110.974C147.193 109.125 146.527 107.357 145.465 105.828C144.403 104.3 142.979 103.059 141.319 102.217C139.66 101.375 137.817 100.958 135.957 101.003L136.23 112.246L128.278 120.198Z",
    fill: "#B3B3B3"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 112.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 112.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.23,
    cy: 112.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 112.246,
    r: 11.3585,
    fill: "white",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 112.246,
    r: 11.3585,
    fill: "#B3B3B3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 112.246,
    r: 11.246,
    fill: "#B3B3B3"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 112.246,
    r: 9.33421,
    fill: "#F3F3F3",
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 112.246,
    r: 11.3585,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.722,
    cy: 112.246,
    r: 9.33421,
    stroke: "#DDDDDD",
    strokeWidth: 0.224921
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetStatus);
export default __webpack_public_path__ + "static/media/TimesheetStatus.4762fb3f9465ca7e9e94cf8973ff5379.svg";
export { ForwardRef as ReactComponent };